import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { API, ADMIN_TOKEN_KEY, errMsg } from "@/lib/api";

export default function AdminLoginPage() {
  const [f, setF] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const qc = useQueryClient();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin-auth/login`, f);
      localStorage.setItem(ADMIN_TOKEN_KEY, r.data.token);
      await qc.invalidateQueries({ queryKey: ["admin-session"] });
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-4 py-16">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 rounded-sm p-8 space-y-5" data-testid="admin-login-form">
        <div className="space-y-2">
          <span className="h-11 w-11 bg-[#0A192F] rounded-sm flex items-center justify-center"><ShieldCheck className="h-6 w-6 text-[#FF6B00]" /></span>
          <h1 className="text-2xl font-extrabold tracking-tight text-[#0A192F]">Admin login</h1>
          <p className="text-sm text-slate-500">Staff access to the Inla Shipping Hub control panel.</p>
        </div>
        <div className="space-y-1.5"><Label htmlFor="admin-username">Username</Label>
          <Input id="admin-username" autoComplete="username" required value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} data-testid="admin-username-input" /></div>
        <div className="space-y-1.5"><Label htmlFor="admin-password">Password</Label>
          <Input id="admin-password" type="password" autoComplete="current-password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-password-input" /></div>
        <Button type="submit" disabled={busy} className="w-full h-11 bg-[#FF6B00] hover:bg-[#E05D00]" data-testid="admin-login-submit">
          {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Sign in
        </Button>
        <p className="text-xs text-slate-500 text-center">Customer? <Link to="/sign-in" className="text-[#FF6B00] font-medium" data-testid="admin-login-customer-link">Sign in here</Link></p>
      </form>
    </div>
  );
}
